import React, { useState, useEffect, MutableRefObject } from 'react'
import styleSearch from './Search.module.scss'

interface ISearchProps {
  value?: string | number
  label?: string
  isFixed?: boolean | false
  type?: string | 'text'
  reference?: React.MutableRefObject<HTMLInputElement>
  disabled?: boolean | false
  isFocus?: boolean | false
  isDashed?: boolean | false
  onChange?: () => void
}
export type SearchProps = ISearchProps

export const Search = (props: SearchProps): JSX.Element => {
  const [value, setValue] = useState(props.value ? String(props.value) : null)
  const [label, setLabel] = useState(props.label)
  const [isFixed, setIsFixed] = useState(props.isFixed || false)
  const [type, setType] = useState(props.type || 'text')
  const [reference, setReference] = useState<MutableRefObject<HTMLInputElement>>(props.reference)
  const [disabled, setDisabled] = useState(props.disabled || false)
  const [isFocus, setIsFocus] = useState(props.isFocus || false)
  const [isDashed, setIsDashed] = useState(props.isDashed || false)
  const [time, setTime] = useState<string | number | NodeJS.Timeout>(null)

  useEffect(() => {
    setValue(props.value ? String(props.value) : null)
    if (reference) {
      reference.current.value = (props.value ? props.value : '') as string
    }
    if (props.onChange) {
      props.onChange()
    }
  }, [props.value])

  useEffect(() => {
    return () => {
      setValue(null)
      setLabel(null)
      setIsFixed(false)
      setType('text')
      setReference(null)
      setDisabled(false)
      setIsFocus(false)
      setIsDashed(false)
      if (time) {
        clearInterval(time)
        setTime(null)
      }
    }
  }, [])

  useEffect(() => {
    setValue(props.value ? String(props.value) : null)
    setLabel(props.label)
    setIsFixed(props.isFixed || false)
    setType(props.type || 'text')
    setReference(props.reference)
    setDisabled(props.disabled || false)
    setIsFocus(props.isFocus || false)
    setIsDashed(props.isDashed || false)
  }, [
    props.value,
    props.label,
    props.isFixed,
    props.type,
    props.reference,
    props.disabled,
    props.isFocus,
    props.isDashed
  ])

  const classNameValueFocus = (value: string, isFocus: boolean, isFixed: boolean): string | null => {
    if (isFocus) {
      return styleSearch._field__box_value + ' ' + styleSearch._field__box_focused
    } else if (isFixed) {
      return styleSearch._field__box_value
    } else if (value) {
      return styleSearch._field__box_value
    }

    return null
  }

  const changeInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value)
    if (
      (String(event.target.value).length > 1 ||
        String(event.target.value).length === 0) &&
      !!props.onChange
    ) {
      if (time) {
        clearInterval(time)
        setTime(null)
      }

      setTime(
        setTimeout((): void => {
          props.onChange()
        }, 500)
      )
    }
  }

  return (
    <div className={styleSearch._field}>
      <div
        className={
          styleSearch._field__box +
          (classNameValueFocus(value, isFocus, isFixed)
            ? ' ' + classNameValueFocus(value, isFocus, isFixed)
            : '') +
          (isDashed ? ' ' + styleSearch._field__box_dashed : '')
        }
      >
        <label>
          {label && (
            <span className={styleSearch._field__label}>
              {label}
            </span>
          )}
          <input
            className={styleSearch._field__input}
            type={(!!type && type) || 'text'}
            defaultValue={(!!value && value) || undefined}
            autoComplete="off"
            disabled={disabled}
            ref={reference || undefined}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeInput(event)
            }}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }}
          />
        </label>
      </div>
    </div>
  )
}
